import React, { useEffect, useState } from "react";
import { AuthConsumer } from "../main/provedorAutenticacao";
import SidebarLeft from "./sidebar_left";
import AuthService from "../app/service/authService";


function Navbar(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [usuarioLogado, setUsuarioLogado] = useState(null); // Estado para armazenar usuário
    

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  
  useEffect ( () => {
    const usuario = AuthService.obterUsuarioAutenticado();

    if(usuario){
      console.log("Usuário logado:", usuario);
      setUsuarioLogado(usuario);
    }

  }, [props.isUsuarioAutenticado]);
  

  const handleLogout = () => {
    // Removendo token do usuário da sessão/localstorage
    AuthService.removerUsuarioAutenticado();
    setUsuarioLogado(null);

    if(props.deslogar) props.deslogar();
  }; 

  return (
    <div className="flex scroll-y-auto">
      {/* Sidebar (só aparece se não for login) */}
      {props.showSidebar && (
        <SidebarLeft
          isOpen={isOpen}
          toggleSidebar={toggleSidebar}
          isUsuarioAutenticado={props.isUsuarioAutenticado}
          deslogar={handleLogout}

        />
      )}

      {/* Área principal */}
      <div
        className={`flex-1 flex flex-col transition-all duration-300 ${
          props.showSidebar
            ? isOpen
              ? "ml-64"
              : "ml-0 lg:ml-[190px]"
            : "ml-0"
        }`}
      >
        {/* NavBar fixa no topo */}
        <div className="menu-navbar fixed top-0 left-0 right-0 h-24 bg-white shadow flex justify-between items-center px-4 z-40">
          {/* Toggle só aparece em telas pequenas e apenas se houver sidebar */}
          {props.showSidebar && (
            <button
              className="block lg:hidden text-green-600"
              onClick={toggleSidebar}
            >
              <i className="fas fa-bars text-2xl"></i>
            </button>
          )}

          {/* Logo centralizada */}
          <div className="flex-1 flex justify-center">
            <a href="#/home">
              <img
                src="JUCESC-HORIZONTAL.png"
                alt="Logo da aplicação"
                className="logo-site"
              />
            </a>
          </div>

           { props.isUsuarioAutenticado &&  (

            <div className="content-logout">  
                <aside>
                    <div className="user-name">
                        <span>Olá</span>
                        <small className="conteiner-logout-header"><i className="bi bi-person-fill"></i><strong class="username">
                          {usuarioLogado?.username || "Não autenticado"}
                        </strong></small>
                    </div>
                </aside>   
		           <a title="Sair" style={{cursor: "pointer"}} onClick={handleLogout} data-title="Sair">	
			            <i className="bi bi-box-arrow-in-right"></i>
               </a>
            </div>
           )}
           

        </div>

        {/* Conteúdo principal */}
        <main className="pt-15 px-0 md:px-5 lg:px-5 ">
          <div className="bg-main max-w-[1280px] mx-auto md:p-4 lg:p-4 rounded">
            {props.children}
          </div>
        </main>
      </div>
    </div>
  );
}

export default (props) => (
  <AuthConsumer>
    {(context) => (
      <Navbar
        isUsuarioAutenticado={context.isAutenticado}
        deslogar={context.encerrarSessao}
        showSidebar={props.showSidebar} // <- controle vem de rotas.js
      >
        {props.children}
      </Navbar>
    )}
  </AuthConsumer>
);
